import { render, staticRenderFns } from "./BasicSports.vue?vue&type=template&id=69d88112&scoped=true&"
import script from "./BasicSports.vue?vue&type=script&lang=js&"
export * from "./BasicSports.vue?vue&type=script&lang=js&"
import style0 from "./BasicSports.vue?vue&type=style&index=0&id=69d88112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d88112",
  null
  
)

component.options.__file = "BasicSports.vue"
export default component.exports